(function ($, ko) {

    ko.bindingHandlers.chartDonut = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            if (!val) return;

            //chart settings
            var chartData = {
                element: element,
                colorScheme: val.colorScheme,
                dataArr: val.data
            };
            //create the chart
            $.cdh.charts.bindDonutChart(chartData, val.options);
        }
    };

    ko.bindingHandlers.chartDonutLegend = {
        update: function (element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());
            if (!val) return;

            //Add colors to legends
            var colorScheme = $.grep($.jqx._jqxChart.prototype.colorSchemes, function (obj, i) {
                return (obj.name == val.colorScheme);
            });
            var scheme = colorScheme[0];
            const color = scheme.colors[scheme.count / 2 + ko.unwrap(val.index)];
            $(element).css('background', color);

            const patternIndex = ko.unwrap(val.index) === 1 ? '0' : '1';
            const pattern = $.cdh.helper.makeTagPattern(color, patternIndex);
            const svg = $.cdh.helper.makePatternSvg(pattern);
            element.innerHTML += svg;
        }
    };

})(jQuery, ko);